import { render, staticRenderFns } from "./colorpicker.vue?vue&type=template&id=799eabb6&scoped=true&"
import script from "./colorpicker.vue?vue&type=script&lang=js&"
export * from "./colorpicker.vue?vue&type=script&lang=js&"
import style0 from "./colorpicker.vue?vue&type=style&index=0&id=799eabb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799eabb6",
  null
  
)

export default component.exports